<template>
    <div id="app" class="font-sans antialiased bg-white">
        <app-navbar />
        <router-view />
        <app-footer />
    </div>
</template>
<script>
import AppFooter from '@/components/AppFooter';
import AppNavbar from '@/components/AppNavbar';

export default {
    name: 'app',
    components: { AppFooter, AppNavbar },
};
</script>
<style>
body {
    margin: 0 !important;
}
</style>
